export default "__VITE_ASSET__Dg3fks$A__"